import { dispatch } from '../../store'
import { db } from '../firebase'
const adminCountersRef = db.ref('/counter/admin/')

export const watchAdminCounters = (unwatch) => {
    if(unwatch){
        adminCountersRef.child('events').off()
        adminCountersRef.child('connectedEvents').off()
        adminCountersRef.child('confirmedEvents').off()
    }
    adminCountersRef.child('events/count').on('value', eventCounter =>{
        return dispatch({type: 'ADMIN_EVENTS_COUNTER', payload: eventCounter.exists() ? eventCounter.val() : 0})
    })
    
    adminCountersRef.child('connectedEvents/count').on('value', connectedEvent =>
        dispatch({type: 'ADMIN_CONNECTED_EVENTS_COUNTER', payload: connectedEvent.exists() ? connectedEvent.val() : 0}))
    
    adminCountersRef.child('confirmedEvents/count').on('value', confirmedEvent =>
        dispatch({type: 'ADMIN_CONFIRMED_EVENTS_COUNTER', payload: confirmedEvent.exists() ? confirmedEvent.val() : 0}))
    
    adminCountersRef.child('users/count').on('value', users =>
        dispatch({type: 'ADMIN_USERS_COUNTER', payload: users.exists() ? users.val() : 0}))

    adminCountersRef.child('importedUsers/count').on('value', importedUsers =>
        dispatch({type: 'ADMIN_IMPORTEDUSERS_COUNTER', payload: importedUsers.exists() ? importedUsers.val() : 0}))

        adminCountersRef.child('usersOnline/count').on('value', usersOnline =>
        dispatch({type: 'ADMIN_USERSONLINE_COUNTER', payload: usersOnline.exists() ? usersOnline.val() : 0}))



}


// WEBPACK FOOTER //
// ./src/firebase/database/handleCounter.js